module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "access-token-class-components-Navigation"
  }, [(_vm.device == 'pc') ? _c('div', {
    staticClass: "content pc cr666 font14"
  }, [_c(_vm.indexComponent, {
    tag: "div",
    staticClass: "index"
  })]) : _vm._e(), _vm._v(" "), (_vm.device == 'pad') ? _c('div', {
    staticClass: "content pad cr666 font14"
  }, [_c(_vm.indexComponent, {
    tag: "div",
    staticClass: "index"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f6e96fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/index.vue
// module id = 426
// module chunks = 2